import type { StyleCategoryId } from './types';

export interface StyleCategoryMeta {
  id: StyleCategoryId;
  label: string;
}

/** Display order + labels for the clipboard chip and the selective-paste checklist. */
export const STYLE_CATEGORIES: StyleCategoryMeta[] = [
  { id: 'fill', label: 'Заливка' },
  { id: 'stroke', label: 'Обводка' },
  { id: 'typography', label: 'Типографика' },
  { id: 'opacity', label: 'Прозрачность' },
  { id: 'cornerRadius', label: 'Скругление' },
  { id: 'size', label: 'Размер' },
];

/**
 * Visual categories (everything except size). Used as the default selection
 * in the selective-paste checklist, where size stays an explicit checkbox.
 */
export const ALL_VISUAL_CATEGORIES: StyleCategoryId[] = ['fill', 'stroke', 'typography', 'opacity', 'cornerRadius'];

/** What "paste style" (the button and Ctrl/⌘+Shift+V) transfers — size included. */
export const ALL_STYLE_CATEGORY_IDS: StyleCategoryId[] = [...ALL_VISUAL_CATEGORIES, 'size'];
